import type { DisplayInfo } from '@/types/agent';

/** Host-space bounding rectangle used by the desktop renderer. */
export interface VirtualDesktopBounds {
  left: number;
  top: number;
  width: number;
  height: number;
}

export function virtualDesktopBounds(displays: DisplayInfo[]): VirtualDesktopBounds | null {
  const usable = displays.filter((d) => d.width > 0 && d.height > 0);
  if (!usable.length) return null;
  const left = Math.min(...usable.map((d) => d.left));
  const top = Math.min(...usable.map((d) => d.top));
  const right = Math.max(...usable.map((d) => d.left + d.width));
  const bottom = Math.max(...usable.map((d) => d.top + d.height));
  return { left, top, width: right - left, height: bottom - top };
}

/** Percentage rect for one monitor in a canvas preserving host geometry. */
export function displayCanvasRect(display: DisplayInfo, bounds: VirtualDesktopBounds) {
  return {
    left: ((display.left - bounds.left) / bounds.width) * 100,
    top: ((display.top - bounds.top) / bounds.height) * 100,
    width: (display.width / bounds.width) * 100,
    height: (display.height / bounds.height) * 100,
  };
}
